import React from "react";
import "style/FeatureCards.scss";

import Reveal from "components/Reveal";

interface Item {
  ID: number;
  NAME: string;
  TITLE: string;
  TEXT: string;
}

interface Props {
  items: Item[];
}

const FeatureCards: React.FC<Props> = ({ items }) => {
  return (
    <div className="feature-grid">
      {items &&
        items.map((item, index) => {
          const img = require(`assets/image/${item.NAME}.webp`);
          return (
            <Reveal key={item.ID} className="feature-cell" delay={index * 70}>
              <article className="feature-card">
                <div className="feature-card__media">
                  <img src={img} alt={item.TITLE} loading="lazy" />
                  <span className="feature-card__step">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="feature-card__body">
                  <h3>{item.TITLE}</h3>
                  <p>{item.TEXT}</p>
                </div>
              </article>
            </Reveal>
          );
        })}
    </div>
  );
};

export default FeatureCards;
